<template>
  <b-container v-if="this.pagesCount > 1" class="pagination-nav" fluid>
    <b-container>
      <b-row>
        <b-col class="d-flex justify-content-around align-items-center py-2">
          <b-button
            variant="link"
            :to="{ name: routeName, query: mergeQuery({ p: 1 }) }"
            :disabled="+page <= 1"
          >
            <b-icon icon="skip-backward-fill" aria-hidden="true" />
            <span class="d-none d-md-inline"> First</span>
          </b-button>
          <b-button
            variant="link"
            :to="{ name: routeName, query: mergeQuery({ p: +page - 1 }) }"
            :disabled="+page <= 1"
          >
            <b-icon icon="skip-start-fill" aria-hidden="true" />
            <span class="d-none d-md-inline">Prev</span>
          </b-button>
          <div>
            <strong>{{ pageToLocale }}</strong> / {{ pagesCountToLocale }}
          </div>
          <b-button
            variant="link"
            :to="{ name: routeName, query: mergeQuery({ p: +page + 1 }) }"
            :disabled="+page >= +pagesCount"
          >
            <span class="d-none d-md-inline">Next</span>
            <b-icon icon="skip-end-fill" aria-hidden="true" />
          </b-button>
          <b-button
            variant="link"
            :to="{ name: routeName, query: mergeQuery({ p: +pagesCount }) }"
            :disabled="+page >= +pagesCount"
          >
            <span class="d-none d-md-inline">Last </span>
            <b-icon icon="skip-forward-fill" aria-hidden="true" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: "PaginationNav",
  props: ["page", "pagesCount", "routeName"],
  computed: {
    pageToLocale() {
      return Number(this.page).toLocaleString();
    },
    pagesCountToLocale() {
      return Number(this.pagesCount).toLocaleString();
    },
  },
  methods: {
    mergeQuery(query) {
      return Object.assign({}, this.$route.query, query);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-nav {
  background-color: #fff;
  box-shadow: 0 -0.5rem 1rem rgba(0, 0, 0, 0.15);
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>